import { SETTING_TYPE } from '@/constants/enum';
import { previewOptionSelector } from '@/redux/slice/preview.slice';
import { IDetailLocationInfor } from '@/types/components/location';
import { useSelector } from 'react-redux';
import Delivery from './Delivery';
import Pickup from './Pickup';

interface Props {
  listLocations?: (IDetailLocationInfor | undefined)[];
}

const RenderWidget = ({ listLocations }: Props) => {
  const previewOptions = useSelector(previewOptionSelector);

  switch (previewOptions.methods.find((item) => item.selected)?.key) {
    case SETTING_TYPE.PICKUP:
      return <Pickup listLocations={listLocations} />;
    case SETTING_TYPE.DELIVERY:
      return <Delivery />;
    default: {
      return null;
    }
  }
};

export default RenderWidget;
